module.exports = __webpack_public_path__ + "img/Support-skill-123.9dfa2858.png";